import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,{attrs:{"type":_vm.type,"readonly":_vm.readonly,"clearable":!_vm.readonly,"dense":"","outlined":"","hide-details":"","label":_vm.label || undefined},on:{"input":_vm.HandleInput,"change":_vm.HandleChange},model:{value:(_vm.local_value),callback:function ($$v) {_vm.local_value=$$v},expression:"local_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }